import React from 'react';
import { Router, Redirect, Switch, Route } from "react-router-dom";
import Menu from './Menu';
import Informes from './informes/Main';
import Usuarios from './usuarios/Main';

class Main extends React.Component {
  constructor(props) {
    super(props);
    this.state={}
  }

  render(){
    return(
      <Router history={this.props.history}>
        <div className="Todo Configuraciones">
          <h2>Configuraciones</h2>
          <Menu history={this.props.history}/>
          <Switch>
            <Route
              path="/configuraciones/usuarios"
              component={(props) =>
                <Usuarios />
              }
            />
            <Route
              path="/configuraciones/informes"
              component={(props) =>
                <Informes />
              }
            />
            <Route exact path="/configuraciones">
              <Redirect to="/configuraciones/padron" />
            </Route>
            <Route path="/configuraciones/*">
              <Redirect to="/configuraciones/padron" />
            </Route>
          </Switch>
        </div>
      </Router>
    );
  }
}

export default Main;
